<script lang="ts">
import { defineComponent } from 'vue'
import ButtonFollow from '@/components/follow/ButtonFollow.vue'

export default defineComponent({
  name: 'StoryFollowCTA',

  components: {
    ButtonFollow,
  },

  props: {
    /**
     * フォロー対象の特集 ID
     */
    storyId: {
      type: Number,
      required: true,
    },

    /**
     * フォローしているかどうか
     * @description true: フォロー中, false: 未フォロー
     */
    isActive: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['update:follow'],
})
</script>

<template>
  <div class="l-unit__followCTA">
    <div class="l-unit__followCTA--header">
      <div class="o-heading__followCTA">
        <p class="o-heading__followCTA--item">
          気になる続編を見逃さない！
        </p>
      <!-- /.o-heading__followCTA --></div>
    <!-- /.l-unit__followCTA header --></div>

    <div class="l-unit__followCTA--action">
      <ButtonFollow
        type="story"
        :target-id="storyId"
        :is-active="isActive"
        @update:follow="$emit('update:follow', $event)" />
    <!-- /.l-unit__followCTA action --></div>
  <!-- /.l-unit__followCTA --></div>
</template>

<style lang="sass" scoped>
// layout
.l-unit__followCTA
  display: flex
  align-items: center

  & &--header
    margin-left: 0.5em

  & &--action
    width: changeSizePx2Em(164)
    order: -1

// object
.o-heading__followCTA
  $root: &

  $icon-width-px: 5
  $icon-height-px: 10
  $icon-margin: 8
  position: relative
  padding-left: changeSizePx2Em($icon-width-px + $icon-margin)

  &::before
    +iconTriangle($direction: left, $color: $bg-dark-orange, $width: changeSizePx2Em($icon-width-px), $height: changeSizePx2Em($icon-height-px))
    position: absolute
    top: 50%
    left: 0
    transform: translateY(-50%)

  & &--item
    line-height: 1
    color: $font-gray
    font:
      size: $font-small
      weight: bold
</style>
